module.exports = __webpack_public_path__ + "media/images/body-bgr-right-b57a9b76921780f1b4b46562ba92e697.png";